<template>
	<div class="m-link-area">
		<img v-if="image" :src="image" alt="">
		<p v-else class="unit-empty"></p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				image: '',
				areaList: []
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				if (data.data) {
					data = data.data;
					this.image = data.image;
					this.areaList = data.list;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-link-area {
		img {
			width: 100%;
			max-height: none;
		}
	}
</style>
